import React, { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroCarousel from './components/HeroCarousel';
import LocationHours from './components/LocationHours';
import FeaturedMenu from './components/FeaturedMenu';
import ValueProposition from './components/ValueProposition';
import CustomerReviews from './components/CustomerReviews';
import CTASection from './components/CTASection';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleWhatsAppOrder = (dishName, dishPrice) => {
    let message = 'Hello%20Chapati%20Plus!%20I%20would%20like%20to%20place%20an%20order.';
    
    if (dishName && dishPrice) {
      message = `Hello%20Chapati%20Plus!%20I%20would%20like%20to%20order:%0A%0A${encodeURIComponent(dishName)}%20-%20${encodeURIComponent(dishPrice)}`;
    }
    
    window.open(`https://wa.me/211911027181?text=${message}`, '_blank');
  };

  const handleCallOrder = () => {
    window.open('tel:+211911027181', '_self');
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1 pt-16">
        <HeroCarousel 
          onWhatsAppOrder={handleWhatsAppOrder}
          onCallOrder={handleCallOrder}
        />
        
        <LocationHours />
        
        <ValueProposition />
        
        <FeaturedMenu onOrderClick={handleWhatsAppOrder} />
        
        <CustomerReviews />
        
        <CTASection 
          onWhatsAppOrder={handleWhatsAppOrder}
          onCallOrder={handleCallOrder}
        />
      </main>

      <Footer />
    </div>
  );
};

export default Homepage;